module.exports = __webpack_public_path__ + "static/nexus-logo-f37095860e2aa5364134c63f2a0191c6.svg";